import { useState } from 'react';
import loadable from '@loadable/component';
import classNames from 'classnames';

import { useFragmentContext } from '@jsmdg/react-fragment-scripts/fragment';
import {
    ClickElement,
    GA4EventName,
    GA4FeatureCategory,
    trackAnalyticsEvent,
} from '@jsmdg/tracking';
import { InfoIcon, PureButton } from '@jsmdg/yoshi';
import { type ProductDetailContext } from '../../types/types';
import styles from './FriendsDiscountBadge.module.scss';

const LoadableFriendsDiscountModal = loadable(
    async () => import('../FriendsDiscountModal/FriendsDiscountModal'),
);

function trackBadgeClick(clickText: string): void {
    setTimeout(() => {
        trackAnalyticsEvent({
            eventData: {
                eventName: GA4EventName.ClickButton,
                feature_category: GA4FeatureCategory.ProductdetailBuybox,
                click_element: ClickElement.BuddyVoucherInfo,
                click_text: clickText,
            },
        });
    }, 0);
}

type FriendsDiscountBadgeProps = {
    readonly className?: string;
};

const FriendsDiscountBadge = ({ className }: FriendsDiscountBadgeProps): JSX.Element => {
    const [showModal, setShowModal] = useState(false);
    const { tenantConfig } = useFragmentContext<ProductDetailContext>();

    const toggleModal = (): void => {
        setShowModal(!showModal);
        if (!showModal) {
            trackBadgeClick(tenantConfig.friendsRabattText);
        }
    };

    return (
        <>
            {showModal && <LoadableFriendsDiscountModal onRequestClose={toggleModal} />}
            <PureButton
                className={classNames('d-flex', className, styles.badgeContainer)}
                onClick={toggleModal}
            >
                <div
                    className={classNames(
                        'd-flex align-items-center pl-1x pr-3x py-0-5x',
                        styles.badgeTextContainer,
                    )}
                >
                    <div className={classNames('font-complementary', styles.badgeText)}>
                        {tenantConfig.friendsRabattText}
                    </div>
                    <div className={classNames('d-flex align-items-center', styles.badgeIcon)}>
                        <InfoIcon color="#000000" size={27} />
                    </div>
                </div>
            </PureButton>
        </>
    );
};

export { FriendsDiscountBadge };
